var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        fill: "none",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_169_1273)" } }, [
        _c("path", {
          attrs: {
            d: "M0.833252 9.16659L9.16659 0.833252",
            stroke: "white",
            "stroke-width": "1.66667",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M0.833252 0.833252H9.16659V9.16659",
            stroke: "white",
            "stroke-width": "1.66667",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_169_1273" } }, [
          _c("rect", { attrs: { width: "10", height: "10", fill: "white" } }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }